"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ViewWithImageBackground_1 = __importDefault(require("../../../ViewWithImageBackground"));
const ControlRendererContext_1 = __importDefault(require("../../../../../ControlRendererContext"));
const ContainerRendererWrapper = ({ control, isContainerViewScroll, style, events, children, }) => {
    const { wrappers: { renderChildrenWrapper, renderControlWrapper }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const controlIsInnerContainer = control.tag === 'View' && control.containerType !== 'wrapper';
    const controlIsWrapperContainer = control.tag === 'View' && control.containerType === 'wrapper';
    const shouldApplyChildrenWrapper = !!(renderChildrenWrapper && controlIsInnerContainer);
    const shouldRemovePositionAbsolute = controlIsInnerContainer
        || (controlIsWrapperContainer
            && !!renderControlWrapper);
    const withChildrenWrapperStyle = (0, react_1.useMemo)(() => {
        if (shouldApplyChildrenWrapper) {
            return { width: '100%', height: '100%' };
        }
        const newStyle = Object.assign({}, style);
        if (shouldRemovePositionAbsolute) {
            delete newStyle.position;
        }
        return newStyle;
    }, [style, shouldApplyChildrenWrapper, shouldRemovePositionAbsolute]);
    const formatedChildren = (shouldApplyChildrenWrapper && renderChildrenWrapper)
        ? renderChildrenWrapper({
            isContainerViewScroll,
            control,
            style,
            children,
        })
        : children;
    return (react_1.default.createElement(ViewWithImageBackground_1.default, { isContainerViewScroll: isContainerViewScroll, style: withChildrenWrapperStyle, resizeMode: (control.tag === 'View' && control.resizeMode) || undefined, backgroundImage: (control.tag === 'View' && control.backgroundImage) || undefined, events: events }, formatedChildren));
};
ContainerRendererWrapper.defaultProps = {
    isContainerViewScroll: {},
};
exports.default = ContainerRendererWrapper;
